<template>
  <div class="page">
    <section class="content-section secondary">
      <div class="section-title">
          <!-- <div class="section-title-line"></div> -->
          <h1 style="color:white">UNSER TEAM</h1>
          <!-- <div class="section-title-line"></div> -->
      </div>
      <section class="container rows">
        <div class="row full">
          <div class="history-year column quarter">
            <div class="column-image"><img src="https://www.marmor-kunze.de/static/images/IMG_9888_low.jpg"></div>
            <div class="column-title">Frank Kunze</div>
          </div>
          <div class="history-info column three-quarter">
            <div class="info-text">Steinmetzmeister, Steintechniker & Geschäftsführer</div>
          </div>
        </div>
        <div class="row full">
          <div class="history-year column quarter reverse">
            <div class="column-image"><img src="https://www.marmor-kunze.de/static/images/IMG_9890_low.jpg"></div>
            <div class="column-title">Alex Wahl</div>
          </div>
          <div class="history-info column three-quarter">
            <div class="info-text">Produktion & Montage</div>
          </div>
        </div>
        <div class="row full">
          <div class="history-year column quarter reverse">
            <div class="column-image"><img src="https://www.marmor-kunze.de/static/images/IMG_9874_low.jpg"></div>
            <div class="column-title">Etienne Schriefers</div>
          </div>
          <div class="history-info column three-quarter">
            <div class="info-text">Auszubildener (Naturwerksteinmechaniker)</div>
          </div>
        </div>
      </section>
      </section>
  </div>
</template>

<script>
export default {
    name: "UnserTeam",
    metaInfo: {
        title: "Unser Team in Mönchengladbach",
        meta: [
            {
                vmid: "description",
                name: "description",
                content:
                    "Unser Team besteht aus Frank Kunze (Geschäftsführer, Steinmetzmeister und Steintechniker), Alex Wahl (Produktion und Montage) und Etienne Schriefers (Auszubildener Natursteinmechaniker)"
            },
            {
                vmid: "keywords",
                name: "keywords",
                content:
                    "Naturstein Mönchengladbach, Naturstein Team Mönchengladbach, Steinmetzmeister, Steintechniker, Natursteinmechaniker "
            }
        ],
        links: [
            { rel: "canonical", href: "https://www.marmor-kunze.de/unser-team" }
        ]
    }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/UnserTeam.vue